/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbTeamSummary
 */
export interface HchbTeamSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    external_id?: string;
}

/**
 * Check if a given object implements the HchbTeamSummary interface.
 */
export function instanceOfHchbTeamSummary(value: object): value is HchbTeamSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function HchbTeamSummaryFromJSON(json: any): HchbTeamSummary {
    return HchbTeamSummaryFromJSONTyped(json, false);
}

export function HchbTeamSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbTeamSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
    };
}

export function HchbTeamSummaryToJSON(json: any): HchbTeamSummary {
    return HchbTeamSummaryToJSONTyped(json, false);
}

export function HchbTeamSummaryToJSONTyped(value?: HchbTeamSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'external_id': value['external_id'],
    };
}

